// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".coupon-background.blue[data-v-3856c6b6]{background:linear-gradient(72deg, #ffffff 0%, #ffffff 70%, #009ee0 70%, #009ee0 100%)}.coupon-background.red[data-v-3856c6b6]{background:linear-gradient(72deg, #ffffff 0%, #ffffff 70%, #e50017 70%, #e50017 100%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
